import MidiEffect from './MidiEffect.js';
import RackableEffect from '../rack/RackableEffect.js';
import ConfigurableRack from '../rack/ConfigurableRack.js';
import MacroMixin from '../MacroMixin.js';
import {getMidiEffect} from './getMidiEffect.js';

class MidiEffectRack extends RackableEffect(ConfigurableRack(MacroMixin(MidiEffect))) {
    constructor(sequencerEngine) {
        super('Midi Effect Rack', sequencerEngine);

        this.initializeConfigurations(this.adjacencyLists);

        this.initCache(128);
        // this.outputNode.id = 'speakers-' + this.id;
    }

    stop() {
        this.effects.forEach(e => e.stop());
    }

    output(time, stepNumber, actualStepNumber) {
        let finalTriggers = [];
        let q = [];
        let root = this.inputNode;
        q.push(root);

        while (q.length > 0) {
            let v = q.shift();
            let triggers = v.output ?
                v.output(time, stepNumber, actualStepNumber)  :
                [... this.triggers];

            if (this.adjacencyLists[v.id] === undefined) {
                continue;
            }

            for (let edge of this.adjacencyLists[v.id]) {
                let w = edge.effect;
                let p  = edge.probability;
                edge.triggerCount = 0;

                if (Math.random() >= p / 100.0) {
                    continue;
                }

                // todo: make sure infinite loop doesn't happen
                if (w.input) {
                    triggers
                        .filter(t => t.outputNumber === edge.outputNumber)
                        .forEach(
                        t =>
                            // this probably is bad to be passing this shit through
                            // w/o copying, however this does keep us from having
                            // to use mad stepdatas
                                {
                                    edge.triggerCount++;
                                    if (this.adjacencyLists[v.id].length > 1) {
                                        t = this.copyTrigger(t);
                                    }
                                    w.input(t, t.time === undefined);
                                }); 
                } else {
                    // it's the last triggers
                    let trigs = triggers.filter(trig => trig.outputNumber === edge.outputNumber);
                    edge.triggerCount+= trigs.length;
                    finalTriggers = [... finalTriggers, ... trigs];
                }
                w.parent = v;
                q.push(w);
            }
        }

        return finalTriggers;
    }

    get documentation() {
        return [
            "Patch Midi Effects together in non-linear ways. ",
            "The edges control the probability that a trigger is passed through to the next effect."
            ];
    }

    onNewStep() {
        this.triggers = [];
        this.effects.forEach(
            e => e.onNewStep());
    }

    clear() {
        this.counter = 0;
        this.effects.forEach(
            e => e.clear());
        this.triggers = [];
    }

    get isRack() {
        return true;
    }

    // need to call addNote when live triggering
    isRealTime() {
        if (this.adjacencyLists[-1] === undefined) {
            return true;
        }

        return !this.adjacencyLists[-1].some(
            (r) => r.effect && r.effect.isRealTime && !r.effect.isRealTime());
    }

    addNote(transpose, sliceNumber=0, stepNumber=0) {
        this.adjacencyLists[-1].filter(
            r => r.effect && r.effect.isRealTime && !r.effect.isRealTime())
            .forEach(({effect}) => effect.addNote(transpose, sliceNumber, stepNumber));
    }

    removeNote(note, sliceNumber) {
        this.effects.filter(
            effect => effect.isRealTime && !effect.isRealTime())
            .forEach(
                effect => effect.removeNote(note, sliceNumber));
    }

    getJson() {
        return this.getRackJson();
    }

    fromJson(json, isCopy, x, isCopy2, isCopy3=isCopy) {
        this.adjacencyLists = {};
        this.initializeConfigurations(this.adjacencyLists, false);
        this.effects = [];
        this.loaded = false;
        let bulk = super.fromJson(json, isCopy);

        let {effects} = json;
        for (let i in effects) {
            let jsonEffect = effects[i];
            let effect = getMidiEffect(jsonEffect, this.track);
            bulk = {
                ... bulk,
                ... effect.fromJson(jsonEffect, isCopy3)
            };
            if (effect.id !== jsonEffect.id) {
                for (let config of json.configurations) {
                    let adj = config[jsonEffect.id];
                    config[effect.id] = adj;
                    delete config[jsonEffect.id];
                }
            }
            this.addEffect(effect, false);
            effect.x = jsonEffect._x || jsonEffect.x;
            effect.y = jsonEffect._y || jsonEffect.y;
        }

        this.fromRackJson(json, isCopy);
        this.loaded = true;
        // this.outputNode.id = 'speakers-' + this.id;
        return bulk;
    }
   
    getCopy(track, ignoreId=true) {
        let effect = new MidiEffectRack(track);
        effect.fromJson(this.getJson(), ignoreId);
        return effect;
    }

    deleteEdge(edge) {
        super.deleteEdge(edge, false);
    }
}

export default MidiEffectRack;
